import styled from 'styled-components'
import { GridBlock } from '../../../../blocks'
import CreationToolSuperCutField from '../../../../../types/super-cut-field'
import FontFile from './fields/font-file'
import FontPreview from './fields/font-preview'

const FIELDS = [
    CreationToolSuperCutField.FontFile,
    CreationToolSuperCutField.FontPreview,
]

const Fields = styled(GridBlock)`
    gap: 30px;
    margin: 30px 0;
`

const CreationCaptureInfoCustomFont = () => {
    const fieldComponents = FIELDS.map((field) => {
        switch (field) {
            case CreationToolSuperCutField.FontFile:
                return FontFile
            case CreationToolSuperCutField.FontPreview:
                return FontPreview
        }
    })

    return (
        <Fields columns={2}>
            {fieldComponents.map((Field, i) => (Field ? <Field key={FIELDS[i]} field={FIELDS[i]} /> : null))}
        </Fields>
    )
}

export default CreationCaptureInfoCustomFont
